import { useQuery, useMutation } from "./urqlHooks";

const GET_F29_DOCUMENTS = `query GetTaxDocumentsByCompanyId($companyId: String!, $period: String!) { 
    getTaxDocumentsByCompanyId(companyId: $companyId, period: $period) { 
        ivaDebito{
            documentCode
            documentCount
            totalNetAmount
            totalNonTaxableAmount
            totalOriginalAmount
            totalTaxableAmount
            totalTaxAmount
            totalNonRecoverableTaxes
            totalRetainedTaxes
            documentsIds
            summary
        }
        ivaCredito
        {
            documentCode
            documentCount
            totalNetAmount
            totalNonTaxableAmount
            totalOriginalAmount
            totalTaxableAmount
            totalTaxAmount
            totalNonRecoverableTaxes
            documentsIds
            summary
        }
        ivaActivoFijo
        {
            documentCode
            documentCount
            totalNetAmount
            totalNonTaxableAmount
            totalOriginalAmount
            totalTaxableAmount
            totalTaxAmount
            totalNonRecoverableTaxes
            documentsIds
            summary
        }
        ivaDin
        {
            documentCode
            documentCount
            totalNetAmount
            totalNonTaxableAmount
            totalOriginalAmount
            totalTaxableAmount
            totalTaxAmount
            totalNonRecoverableTaxes
            documentsIds
            summary
        }
        honorario
        {
            documentCode
            documentCount
            totalNetAmount
            totalNonTaxableAmount
            totalOriginalAmount
            totalTaxableAmount
            totalTaxAmount
            totalNonRecoverableTaxes
            documentsIds
            summary
        }
        ivaRetenido
        {
            documentCode
            documentCount
            totalNetAmount
            totalNonTaxableAmount
            totalOriginalAmount
            totalTaxableAmount
            totalTaxAmount
            totalNonRecoverableTaxes
            documentsIds
            summary
        }
        totalNetForPpm

    }
}`;

export const GetF29Documents = (companyId, period) => {
    const [result, reexecuteQuery] = useQuery({
        query: GET_F29_DOCUMENTS,
        variables: { companyId, period },
        pause: !companyId || !period,
    });
    const { data, fetching, error } = result;
    return { data, fetching, error, reexecuteQuery };
};

const GET_F29_EXCEL = `mutation getF29Excel($input: F29ExcelInput!, $companyId: String!) {
    getF29Excel(input:$input, companyId: $companyId)
  }`;

export const GetF29Excel = () => {
    const [result, executeMutation] = useMutation(GET_F29_EXCEL);
    const { data, fetching, error } = result;
    return { data, fetching, error, executeMutation };
};

const GET_BUK_IMPUESTO_UNICO_AMOUNT = `
  mutation getBukImpuestoUnicoAmount($companyId: String!, $date:DateTime!) {
    getBukImpuestoUnicoAmount(companyId:$companyId, date:$date ){
        impuestoUnicoAmount
        impuestoFiniquitoAmount
        prestamoAmount
        message
        status
    }
  }
`;

export const GetBukImpuestoUnicoAmount = () => {
    const [result, executeMutation] = useMutation(GET_BUK_IMPUESTO_UNICO_AMOUNT);
    const { data, fetching, error } = result;
    return { data, fetching, error, executeMutation };
};

const CREATE_F29 = `
    mutation CREATE_F29($input: F29Input!) {
        createF29(input: $input) {
        id
        montoPPMManual
        editionHistory {
          userId
          userEmail
          date
          field
          event
          previousValue
          newValue
        }
  }
}
`;

export const CreateF29 = () => {
  const [result, executeMutation] = useMutation(CREATE_F29);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };

};

const GET_F29_BY_COMPANYID_PERIOD = `
  query F29_BY_COMPANYID_PERIOD(
  $companyId: String!
  $period: String!
) {
  f29ByCompanyIdPeriod(companyId: $companyId, period:$period) {
      id
      period
      companyId
      remanente
      tasaPPM
      creditoFiscal
      ivaPostergado
      empresaExenta
      noRecuperaIvaCredito
  }
}
`;

export const GetF29ByCompanyIdPeriod = (companyId, period) => {
  const [result, reexecuteQuery] = useQuery({
      query: GET_F29_BY_COMPANYID_PERIOD,
      variables: { companyId, period },
      pause: !companyId || !period,
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_F29 = `
  query GetF29($companyId: String!, $period: String!) {
    getF29(companyId: $companyId, period: $period) {
      id
      period
      companyId
      remanente
      tasaPPM
      montoPPMManual
      creditoFiscal
      ivaPostergado
      empresaExenta
      noRecuperaIvaCredito
      editionHistory {
        userId
        userEmail
        date
        field
        event
        previousValue
        newValue
      }
    }
  }
`;

export const GetF29 = (companyId, period) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_F29,
    variables: { companyId, period },
    pause: !companyId || !period,
    requestPolicy: "cache-and-network",
  });
  const { data, fetching, error, stale } = result;
  return { data, fetching, error, stale, reexecuteQuery };
};

const ALL_F29_BY_COMPANY_ID = `
  query AllF29ByCompanyId($companyId: String!) {
    allF29ByCompanyId(companyId: $companyId) {
      id
      period
      isPaid
      ivaPostergado
      fechaPago
      impuestoUnico
      montoPPM
      montoPPMManual
      retencionHonorarios
      siiDeclaracionExtra
      editionHistory {
        userId
        userEmail
        date
        field
        event
        previousValue
        newValue
      }
    }
  }
`;

export const GetAllF29ByCompanyId = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: ALL_F29_BY_COMPANY_ID,
    variables: { companyId },
    pause: !companyId,
    requestPolicy: "cache-and-network",
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_F29_EMAIL_HISTORY = `
  query GetF29EmailHistory($companyId: String!) {
    getF29EmailHistory(companyId: $companyId) {
      id
      period
      userId
      userEmail
      counterpartEmail
      emailTemplateName
      emailSubject
      emailBodyHtml
      start
      end
      mssg
      status
    }
  }
`;

const GET_F29_PAYMENT_STATUS = `
  query GetF29PaymentStatus($companyId: String!, $period: String!) {
    getF29PaymentStatus(companyId: $companyId, period: $period) {
      status
      fechaPago
      montoPagado
    }
  }
`;

export const GetF29PaymentStatus = (companyId, period, pause = false) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_F29_PAYMENT_STATUS,
    variables: { companyId, period },
    pause: pause || !companyId || !period,
    requestPolicy: "network-only",
  });
  return { ...result, reexecuteQuery };
};

export const GetF29EmailHistory = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_F29_EMAIL_HISTORY,
    variables: { companyId },
    pause: !companyId,
    requestPolicy: "cache-and-network",
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const SET_EMPRESA_EXENTA_F29 = `
    mutation SET_EMPRESA_EXENTA_F29($companyId: String!, $empresaExenta: Boolean!) {
        setEmpresaExentaF29(companyId: $companyId,empresaExenta: $empresaExenta ) {
        id
  }
}
`;

export const SetEmpresaExentaF29 = () => {
  const [result, executeMutation] = useMutation(SET_EMPRESA_EXENTA_F29);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };

};

const SET_NO_RECUPERA_IVA_CREDITO_F29 = `
    mutation SET_NO_RECUPERA_IVA_CREDITO_F29($companyId: String!, $noRecuperaIvaCredito: Boolean!) {
        setNoRecuperaIvaCreditoF29(companyId: $companyId, noRecuperaIvaCredito: $noRecuperaIvaCredito) {
        id
  }
}
`;

export const SetNoRecuperaIvaCreditoF29 = () => {
  const [result, executeMutation] = useMutation(SET_NO_RECUPERA_IVA_CREDITO_F29);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const GET_F29_DIN_DOCUMENTS_DETAIL = `
  query GetF29DinDocumentsDetail($companyId: String!, $period: String!) {
    getF29DinDocumentsDetail(companyId: $companyId, period: $period) {
      fechaPago
      folio
      montoNeto
      montoIva
      montoTotal
    }
  }
`;

export const GetF29DinDocumentsDetail = (companyId, period, pause = false) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_F29_DIN_DOCUMENTS_DETAIL,
    variables: { companyId, period },
    pause: pause || !companyId || !period,
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const SEND_F29_EMAIL = `
  mutation sendF29Email($input: SendEmailInput!) {
    sendTemplateEmail(input: $input) {
      success
      messageId
      error
      timestamp
    }
  }
`;

export const SendF29Email = () => {
  const [result, executeMutation] = useMutation(SEND_F29_EMAIL);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const GET_F29_EMAIL_PREVIEW = `
  query getF29EmailPreview($previewInput: F29EmailPreviewInput!, $companyId: String) {
    getF29EmailPreview(previewInput: $previewInput, companyId: $companyId) {
      subject
      body
    }
  }
`;

export const GetF29EmailPreview = (previewInput) => {
  const [result] = useQuery({
    query: GET_F29_EMAIL_PREVIEW,
    variables: { previewInput },
    pause: !previewInput?.templateName || !previewInput?.templateData,
    requestPolicy: "network-only",
  });
  const { data, fetching, error } = result;
  return { data, fetching, error };
};

const GET_F29_COMPROBANTE_PDF = `
  query getF29ComprobantePdf($companyId: String!, $period: String!) {
    getF29ComprobantePdf(companyId: $companyId, period: $period) {
      success
      message
      pdfBase64
      filename
      folio
    }
  }
`;

export const GetF29ComprobantePdf = ({ companyId, period, pause = false }) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_F29_COMPROBANTE_PDF,
    variables: { companyId, period },
    pause: pause || !companyId || !period,
    requestPolicy: "network-only",
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_F29_COMMENTS = `
  query GET_F29_COMMENTS($companyId: String!, $period: String!) {
    getF29Comments(companyId: $companyId, period: $period) {
      user {
        id
        name
        email
      }
      date
      comment
    }
  }
`;

export const GetF29Comments = ({ companyId, period, pause = true }) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_F29_COMMENTS,
    variables: { companyId, period },
    pause: pause || !companyId || !period,
    requestPolicy: "network-only",
  });
  return {
    data: result.data,
    fetching: result.fetching,
    error: result.error,
    reexecuteQuery: () => reexecuteQuery({ requestPolicy: "network-only" }),
  };
};

const CREATE_F29_COMMENT = `
  mutation CREATE_F29_COMMENT(
    $companyId: String!
    $period: String!
    $userId: String!
    $userName: String
    $userEmail: String
    $date: DateTime!
    $comment: String!
  ) {
    createF29Comment(
      input: {
        companyId: $companyId
        period: $period
        user: {
          id: $userId
          name: $userName
          email: $userEmail
        }
        date: $date
        comment: $comment
      }
    ) {
      id
      innerComments {
        user {
          id
          name
          email
        }
        date
        comment
      }
    }
  }
`;

export const CreateF29Comment = () => {
  const [result, executeMutation] = useMutation(CREATE_F29_COMMENT);
  return {
    data: result.data,
    fetching: result.fetching,
    error: result.error,
    executeMutation: (variables) => executeMutation(variables),
  };
};

const GET_IVA_POSTPONES_BY_COMPANY_ID = `
  query GetIvaPostponesByCompanyId($companyId: String!) {
    getIvaPostponesByCompanyId(companyId: $companyId) {
      id
      companyId
      period
      periodName
      amount
      dueDate
      dueDateStr
      issueDateStr
      isPaid
      isAgreement
    }
  }
`;

export const GetIvaPostponesByCompanyId = (companyId) => {
  const id = companyId != null && companyId !== "" ? String(companyId) : null;
  const [result, reexecuteQuery] = useQuery({
    query: GET_IVA_POSTPONES_BY_COMPANY_ID,
    variables: { companyId: id || "" },
    pause: !id,
    requestPolicy: "cache-and-network",
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const UPDATE_IVA_POSTPONE = `
  mutation UpdateIvaPostpone($input: UpdateIvaPostponeInput!) {
    updateIvaPostpone(input: $input) {
      id
      isPaid
      isAgreement
      updatedAt
    }
  }
`;

export const UpdateIvaPostpone = () => {
  const [result, executeMutation] = useMutation(UPDATE_IVA_POSTPONE);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const UPDATE_MULTIPLE_IVA_POSTPONES = `
  mutation UpdateMultipleIvaPostpones($input: UpdateMultipleIvaPostponesInput!) {
    updateMultipleIvaPostpones(input: $input) {
      id
      isPaid
      isAgreement
      updatedAt
    }
  }
`;

export const UpdateMultipleIvaPostpones = () => {
  const [result, executeMutation] = useMutation(UPDATE_MULTIPLE_IVA_POSTPONES);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const EXECUTE_F29_AUTO_DECLARATION = `
  mutation ExecuteF29AutoDeclaration($companyId: String!, $period: String!, $impuestoUnico: Float, $prestamoSolidario: Float, $tasa: Float, $postIVA: Boolean) {
    executeF29AutoDeclaration(companyId: $companyId, period: $period, impuestoUnico: $impuestoUnico, prestamoSolidario: $prestamoSolidario, tasa: $tasa, postIVA: $postIVA) {
      status
      message
      data
    }
  }
`;

export const ExecuteF29AutoDeclaration = () => {
  const [result, executeMutation] = useMutation(EXECUTE_F29_AUTO_DECLARATION);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const GET_TASA_PPM = `
  query GetTasaPPM($companyId: String!, $period: String!) {
    getTasaPPM(companyId: $companyId, period: $period) {
      tasaPPM
      remanente
    }
  }
`;

export const GetTasaPPM = (companyId, period) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_TASA_PPM,
    variables: { companyId, period },
    pause: !companyId || !period,
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_BUK_VALUES_FOR_PERIOD = `
  query GetBukValuesForPeriod($companyId: String!, $period: String!) {
    getBukValuesForPeriod(companyId: $companyId, period: $period) {
      impuestoUnico
      impuestoFiniquito
      prestamoSolidario
      status
      message
      centralizacionUpdatedAt
      centralizacionHealth
      centralizacionHealthDetail
    }
  }
`;

const REFRESH_CENTRALIZACION_FROM_BUK_F29 = `
  mutation RefreshCentralizacionFromBukForF29($companyId: String!, $period: String!) {
    refreshCentralizacionFromBukForF29(companyId: $companyId, period: $period) {
      success
      message
      totalDocumentos
      creados
      actualizados
    }
  }
`;

export const RefreshCentralizacionFromBukForF29 = () => {
  const [result, executeMutation] = useMutation(REFRESH_CENTRALIZACION_FROM_BUK_F29);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

export const GetBukValuesForPeriod = (companyId, period) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_BUK_VALUES_FOR_PERIOD,
    variables: { companyId, period },
    pause: !companyId || !period,
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const CONSULTAR_DECLARACIONES_F29 = `
  mutation ConsultarDeclaracionesF29($companyId: String!, $year: Float!) {
    consultarDeclaracionesF29(companyId: $companyId, year: $year) {
      status
      message
      data
    }
  }
`;

export const ConsultarDeclaracionesF29 = () => {
  const [result, executeMutation] = useMutation(CONSULTAR_DECLARACIONES_F29);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const GET_VERIFICATION_RESULT = `
  query GetVerificationResult($companyId: String!, $llamada: String!) {
    getVerificationResult(companyId: $companyId, llamada: $llamada) {
      companyId
      llamada
      verificacion {
        success
        message
      }
      status
      message
      period
      timestamp
    }
  }
`;

export const GetVerificationResult = (companyId, llamada) => {
  const llamadaStr =
    llamada != null && llamada !== "" ? String(llamada) : undefined;
  const [result, reexecuteQuery] = useQuery({
    query: GET_VERIFICATION_RESULT,
    variables: { companyId, llamada: llamadaStr },
    pause: !companyId || !llamadaStr,
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

export { GET_VERIFICATION_RESULT };

const GET_DECLARACIONES_CONSULTADAS = `
  query GetDeclaracionesConsultadas($companyId: String!, $year: Float!) {
    getDeclaracionesConsultadas(companyId: $companyId, year: $year) {
      companyId
      year
      resultadosPorMes
      status
      message
      timestamp
    }
  }
`;

export const GetDeclaracionesConsultadas = (companyId, year) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_DECLARACIONES_CONSULTADAS,
    variables: { companyId, year: year != null ? Number(year) : undefined },
    pause: !companyId || year == null || year === "",
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_CM_FACTOR = `
  query GetCmFactor($year: Float!) {
    getCmFactor(year: $year) {
      january
      february
      march
      april
      may
      june
      july
      august
      september
      october
      november
      december
    }
  }
`;

export const GetCmFactor = (year) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_CM_FACTOR,
    variables: { year: year != null ? Number(year) : undefined },
    pause: year == null || year === "",
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_F29_ESTADOS_OBSERVACION = `
  query GetF29EstadosObservacion($companyId: String!) {
    getF29EstadosObservacion(companyId: $companyId) {
      companyId
      period
      accepted
      updatedAt
    }
  }
`;

export const GetF29EstadosObservacion = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_F29_ESTADOS_OBSERVACION,
    variables: { companyId },
    pause: !companyId,
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_FORM29_DEADLINE_INFO = `
  query Form29DeadlineInfo($companyId: String!) {
    form29DeadlineInfo(companyId: $companyId) {
      enabledForElectronicDocuments
      deadlineDay
    }
  }
`;

export const GetForm29DeadlineInfo = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_FORM29_DEADLINE_INFO,
    variables: { companyId },
    pause: !companyId,
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_RENTA_ESTADO_DECLARACION = `
  query GetRentaEstadoDeclaracion($companyId: String!, $year: Float!) {
    getRentaEstadoDeclaracion(companyId: $companyId, year: $year) {
      year
      glosas
      statusEvents {
        nombre
        fechaEvento
      }
      fetchedAt
      updatedAt
    }
  }
`;

export const GetRentaEstadoDeclaracion = (companyId, year) => {
  const normalizedYear =
    year != null && year !== "" ? Number(year) : undefined;
  const [result, reexecuteQuery] = useQuery({
    query: GET_RENTA_ESTADO_DECLARACION,
    variables: { companyId, year: normalizedYear },
    pause: !companyId || normalizedYear == null || Number.isNaN(normalizedYear),
    requestPolicy: "cache-and-network",
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_DJ_STATUS = `
  query GetDjStatus($companyId: String!, $year: Float!) {
    getDjStatus(companyId: $companyId, year: $year) {
      year
      rut
      statusByDj {
        dj
        titulo
        currentEstado
        fechaPresentacion
        fechaVencimiento
      }
      djIntegral {
        dj
        titulo
        estado
        fechaPresentacion
        fechaVencimiento
        estados
      }
      djComunes {
        dj
        titulo
        estado
        fechaPresentacion
        fechaVencimiento
      }
      fetchedAt
      updatedAt
    }
  }
`;

export const GetDjStatus = (companyId, year) => {
  const normalizedYear =
    year != null && year !== "" ? Number(year) : undefined;
  const [result, reexecuteQuery] = useQuery({
    query: GET_DJ_STATUS,
    variables: { companyId, year: normalizedYear },
    pause: !companyId || normalizedYear == null || Number.isNaN(normalizedYear),
    requestPolicy: "cache-and-network",
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const CONSULTAR_DJ_STATUS = `
  mutation ConsultarDjStatus($companyId: String!, $year: Float!) {
    consultarDjStatus(companyId: $companyId, year: $year) {
      status
      message
      data
    }
  }
`;

export const ConsultarDjStatus = () => {
  const [result, executeMutation] = useMutation(CONSULTAR_DJ_STATUS);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const CONSULTAR_ESTADO_DECLARACION_RENTA = `
  mutation ConsultarEstadoDeclaracionRenta($companyId: String!, $year: Float!) {
    consultarEstadoDeclaracionRenta(companyId: $companyId, year: $year) {
      status
      message
      data
    }
  }
`;

export const ConsultarEstadoDeclaracionRenta = () => {
  const [result, executeMutation] = useMutation(CONSULTAR_ESTADO_DECLARACION_RENTA);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const GET_RETENCIONES_HONORARIOS_BTE_ANUAL = `
  query GetRetencionesHonorariosBteAnual($companyId: String!, $year: Int!) {
    getRetencionesHonorariosBteAnual(companyId: $companyId, year: $year) {
      success
      pending
      message
      data {
        period
        amount
      }
    }
  }
`;

const GET_RETENCIONES_HONORARIOS_BTE_ANUAL_STATUS = `
  query GetRetencionesHonorariosBteAnualStatus($companyId: String!, $year: Int!) {
    getRetencionesHonorariosBteAnualStatus(companyId: $companyId, year: $year) {
      success
      pending
      message
      data {
        period
        amount
      }
    }
  }
`;

export {
  GET_DECLARACIONES_CONSULTADAS,
  GET_CM_FACTOR,
  GET_F29_ESTADOS_OBSERVACION,
  GET_RETENCIONES_HONORARIOS_BTE_ANUAL,
  GET_RETENCIONES_HONORARIOS_BTE_ANUAL_STATUS,
};
